import { memo } from "react";
import PropTypes from "prop-types";
import "./PageLayout.scss";

const PageLayout = ({ children }) => {
	return (
		<main className="page-layout">
			<div className="page-layout__container">{children}</div>
		</main>
	);
};

PageLayout.propTypes = {
	children: PropTypes.node,
};

export default memo(PageLayout);
